import { Button, Drawer } from 'antd';
import Brand from '../../assets/brand.png'
import { ButtonGradient } from '../button';
import styles from './Header.module.scss';
import { useState } from 'react';
import { MenuOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

interface IHeaderProps {
    onClickSection: (section: string) => void
}

export const Header = ({ onClickSection }: IHeaderProps) => {
    const { isMobile } = useSelector((state: RootState) => state.data);
    const [showMenu, setShowMenu] = useState<boolean>(false);

    const handlerClickSection = (section?: string) => {
        setShowMenu(false);

        if(section){
            onClickSection(section);
            return;
        }

        window.open("https://app.livingrock.mx", "_blank")
    }

    const renderBtns = () => <>
        <ButtonGradient label="Beneficios" onClick={() => handlerClickSection('benefits')} />
        <ButtonGradient label="Servicios" onClick={() => handlerClickSection('services')} />
        <ButtonGradient label="Plataforma" />
        <ButtonGradient classSpace={isMobile && 'w-full'} label="Acceso clientes" initialGradient onClick={() => handlerClickSection()} />
    </>

    const titleMenu = () => <>
        <img alt='brand' src={Brand} width={180}/>
    </>

    return (
        <div className={styles.contentHeader}>
            <div className={styles.header}>
                <div className={styles.menu}>
                    {isMobile && <Button
                        className="flex items-center"
                        type="text"
                        icon={<MenuOutlined style={{ fontSize: 20, marginTop: 5 }} />}
                        onClick={() => setShowMenu(true)}
                    />}
                    <img alt='brand' src={Brand} />
                </div>
                {!isMobile && <div className={styles.contentBtns}>
                        {renderBtns()}
                </div>}
            </div>
            <Drawer
                title={titleMenu()}
                placement="left"
                closable
                onClose={() => setShowMenu(false)}
                open={showMenu}
                styles={{ body: { padding: 0 } }}
                width={300}
            >
                <div className={styles.contentBtnsMobile}>
                    {renderBtns()}
                </div>
            </Drawer>
        </div>
    )
}
